import {MasterReport} from "./reports";

type OptionalParameter = 'data_type' | 'yop'| "access_type" | "access_method";
export const availableParameter: Record<MasterReport, Record<OptionalParameter, boolean>> = {
  TR: {
    data_type: true,
    yop: true,
    access_type: true,
    access_method: true,
  },
  DR: {
    data_type: true,
    yop: false,
    access_type: false,
    access_method: true,
  },
  PR: {
    data_type: true,
    yop: false,
    access_type: false,
    access_method: true,
  },
  IR: {
    data_type: true,
    yop: true,
    access_type: true,
    access_method: true,
  }
}
